import * as React from 'react';
import {Link} from 'src/rerouter/index';

import css from './top-nav-link.css';


export type Props = React.ComponentProps<typeof Link> & {
  expanded: unknown;
  icon: React.ReactElement<any>;
  label: string;
};

export default ({expanded, icon, label, ...props}: Props) => (
  <Link
    className={css.topNavItem}
    activeClassName={css.topNavItemOn}
    {...props}
    data-qa-id={`select-${label.toLowerCase()}-page`}
  >
    <div className={css.topNavIconContainer}>{icon}</div>
    <span
      className={expanded ? css.topNavTextExpanded : css.topNavTextCollapsed}
    >
      {label}
    </span>
  </Link>
);
